import {CoreSettingsParameters, ISettings, SettingsParametersSchema} from '@gongxigames/framework/core';
import {SlotSettingsParameters} from '@gongxigames/framework/slot';

export type PPSettingsParameters = {
    gameCode: string;
    rgsUrl: string;
    currencyCode: string;
    token: string;
    extraData: string;
    ExtraData: string;
    dontLoadUrlFromParent?: boolean;
    sound?: number;
    disableFullScreen: boolean;
};

export const PP_CLIENT_WRAPPER_SETTINGS_PARAMETERS_SCHEMA: SettingsParametersSchema<PPSettingsParameters> = {
    gameCode: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    rgsUrl: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    currencyCode: {
        readonly: true,
        defaultValue: 'EUR',
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    token: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    extraData: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string',
            parseValue: value => {
                return encodeURIComponent(value);
            }
        }
    },
    ExtraData: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string',
            parseValue: value => {
                return encodeURIComponent(value);
            }
        }
    },
    disableFullScreen: {
        readonly: true,
        defaultValue: false,
        urlParser: {
            typePropertyInURL: 'boolean',
            alias: ['disableFullScreen', 'disablefullscreen']
        }
    },
    dontLoadUrlFromParent: {
        defaultValue: false,
        readonly: true,
        urlParser: {
            alias: ['DontLoadUrlFromParent', 'dontLoadUrlFromParent'],
            typePropertyInURL: 'boolean'
        }
    },
    sound: {
        defaultValue: undefined,
        urlParser: {
            typePropertyInURL: 'string',
            parseValue: value => {
                value = parseFloat(value);

                return Math.min(!isNaN(value) && isFinite(value) ? value : 0.6, 1);
            }
        }
    }
};

export type PPSettings = ISettings<CoreSettingsParameters & SlotSettingsParameters & PPSettingsParameters>;
